export interface GroupLoader {}

export class GroupLoader<T = any> {
  private entries: Set<T>;

  constructor(entries: T[], private complete: () => void) {
    this.entries = new Set(entries);
    this.checkComplete();
  }

  onLoad(item: T) {
    this.entries.delete(item);
    this.checkComplete();
  }

  private checkComplete() {
    if (this.entries.size === 0) {
      this.complete();
    }
  }
}

export default GroupLoader;
